'use client';
import { useSearchParams } from 'next/navigation';

import GameDaySwitches from '@/modules/league/new-components/header/GameDaySwitches';
import UpDownLeagueButtons from '@/modules/league/new-components/header/UpDownLeagueButtons';
import { GameDayInfo } from '@/modules/league/new-components/types';
import { Session } from '@/types/types';
interface PageProps {
  params: { slug: string; sessionId: string; matchDateId: string };
  headerContent: GameDayInfo;
  user?: Session;
  currentSequenceNumber?: number;
  sequenceNumber?: string;
  isAuthorized: boolean;
}
const HeaderActions = ({
  headerContent,
  params,
  user,
  currentSequenceNumber,
  isAuthorized,
}: PageProps) => {
  const { details } = headerContent;
  const searchParams = useSearchParams();
  const pageType = searchParams?.get('tab') || 'rsvp';

  if (pageType === 'change-scores') return null;

  return (
    <div className='mx-auto flex h-auto w-full max-w-screen-xl flex-col gap-4 md:gap-1 lg:w-4/5'>
      {details.rankingType === 'UpDown' && details.DidGenerate2ndSequence ? (
        <UpDownLeagueButtons currentSequenceNumber={currentSequenceNumber} />
      ) : null}
      <GameDaySwitches
        headerContent={headerContent}
        params={params}
        user={user}
        currentSequenceNumber={currentSequenceNumber}
        isAuthorized={isAuthorized}
      />
    </div>
  );
};

export default HeaderActions;
